export default [
    // {
    //     path: '/schedule-date',
    //     name: 'schedule-date',
    //     component: () => import ('./views/ScheduleByDate'),
    //     meta: {
    //         title: 'Horário das aulas por data',
    //         icon: 'mdi-timetable',
    //     }
    // }
]
